import styled from "@emotion/styled";
import React from "react";
import { baseInputCss } from "./Question";
import QuestionWrapper from "./QuestionWrapper";
import Radio from "./Radio";

const RadioLabel = styled.label`
  ${baseInputCss}
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const RadioWrapper = styled.div`
  ${Radio} {
    display: none;
  }
  ${Radio}:checked + ${RadioLabel} {
    border-color: var(--primary-color);
    color: var(--primary-color);
  }
`;

function QuestionRadio(
  props: React.ComponentPropsWithRef<typeof Radio> & Omit<JSX.IntrinsicElements["input"], "type">,
  ref: React.Ref<HTMLInputElement>
) {
  const { children, className, ...rest } = props;
  const id = `key-${props.name}-${props.value}`.replaceAll(" ", "-");
  return (
    <QuestionWrapper>
      <RadioWrapper>
        <Radio {...rest} ref={ref} id={id} />
        <RadioLabel className={className} htmlFor={id}>
          {children}
        </RadioLabel>
      </RadioWrapper>
    </QuestionWrapper>
  );
}

export default React.forwardRef(QuestionRadio);
